<template>
  <div id="app">
    <router-view>
    </router-view>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      isAuthenticated:false
    };
  },
  beforeMount() {
    this.$store.commit('initializeStore');

    const token = this.$store.state.token;

    if(token) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
      axios.defaults.headers.common['Authorization'] = '';
    }
  }
};
</script>

<style>
  :root{
    --colorPrimary: #025FA0 !important;
    --colorSecondary:#2B3D6E !important;
    --white:#ffffff !important;
    --black:#000000 !important;
    --mildBlack: #333 !important;
  }
  @font-face {
    font-family: 'montserrat';
    src: url('./assets/fonts/Montserrat-Regular.otf') format('opentype'),
         url('./assets/fonts/Montserrat-Bold.otf') format('opentype'),
         url('./assets/fonts/Montserrat-BoldItalic.otf') format('opentype'),
         url('./assets/fonts/Montserrat-Black.otf') format('opentype'),
         url('./assets/fonts/Montserrat-BlackItalic.otf') format('opentype'),
         url('./assets/fonts/Montserrat-ExtraBold.otf') format('opentype'),
         url('./assets/fonts/Montserrat-ExtraBoldItalic.otf') format('opentype');
  }
  @font-face {
    font-family: 'philosopher';
    src: url('./assets/fonts/Philosopher-Regular.ttf') format('truetype'),
         url('./assets/fonts/Philosopher-Bold.ttf') format('truetype'),
         url('./assets/fonts/Philosopher-BoldItalic.ttf') format('truetype'),
         url('./assets/fonts/Philosopher-Italic.ttf') format('truetype');
  }
  @font-face {
    font-family: 'gilroy';
    src: url('./assets/fonts/Gilroy-Bold.ttf') format('truetype'),
         url('./assets/fonts/Gilroy-Bold.woff') format('woff'),
         url('./assets/fonts/Gilroy-ExtraBold.otf') format('opentype'),
         url('./assets/fonts/Gilroy-Heavy.ttf') format('truetype'),
         url('./assets/fonts/Gilroy-Heavy.woff') format('woff'),
         url('./assets/fonts/Gilroy-Light.otf') format('opentype'),
         url('./assets/fonts/Gilroy-Light.ttf') format('truetype'),
         url('./assets/fonts/Gilroy-Light.woff') format('woff'),
         url('./assets/fonts/Gilroy-Medium.ttf') format('truetype'),
         url('./assets/fonts/Gilroy-Medium.woff') format('woff'),
         url('./assets/fonts/Gilroy-Regular.ttf') format('truetype'),
         url('./assets/fonts/Gilroy-Regular.woff') format('woff');
  }

  *{
    font-family: 'montserrat', sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body, p, span {
    font-family: 'montserrat', sans-serif;
  }
  /* h1, h2, h3, h4, h5, h6 {
    font-family: 'philosopher', sans-serif;
  } */
  h1, h2, h3, h4, h5, h6 {
    font-family: 'gilroy', sans-serif;
  }
  a {
    text-decoration: none;
    cursor: pointer;
  }
  button {
    cursor: pointer;
  }
  select {
    color: var(--mildBlack) !important;
    background-color: var(--white) !important;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0 auto;
    position: relative;
  }
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }
  /* RESPONSIVENESS FOR DASHBOARD, SIDE BAR AND HEADER ON DASHBOARD PAGES */
  @media (min-width: 767px) and (max-width: 1100px) {
    .side-bar {
      width: 22% !important;
    }
    .context {
      width: 78% !important;
      margin-left: 22% !important;
    }
    .dashboard-header-container {
      width: 80% !important;
    }
  }
  @media (min-width: 767px) and (max-width: 990px) {
    .dashboard-main {
      padding: 2.5rem 1rem !important;
    }
  }
  @media only screen and (max-width: 576px) {
    .dashboard-main {
      padding: 2.5rem 1rem !important;
    }
  }
  .linked-card {
    cursor: pointer;
  }
</style>
